export default __webpack_public_path__ + "static/media/12-BreakInCaseOfEmergencyDonut.24815ce1.png";